import React, {Component} from 'react'
import PropTypes from "prop-types";
import Error from "../single_components/Error";


class PatientOtherMedicalInfo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            entry: this.props.entry,
        }
    }
    componentDidMount() {

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.entry !== prevProps.entry) {
            this.setState({
                entry: this.props.entry
            })
        }
    }



    Recommendation_letter(value){
        this.props.onYesNoValueChange("Recommendation_letter_use_cannabis",value)
        if (value==="No"){
            this.props.onValueChange("Recommendation_letter_doctor_name", "")
            this.props.onValueChange("treating_physician", "")
        }
    }
    render() {
        let {t} = this.props

        let {entry}= this.state

        return (
            <div className={'patientsFormBoxes'}>

                <div className={'patientsFormRow'}>

                    <div className={'inputSlotsFlex'}>
                        <div className={'infoLabel-error-block'}>

                        <label className={'infoLabel-withError'}>{t('patient_boarding.Recommendation_letter_use_cannabis')}*?</label>
                        <Error isShown={!!(this.props.errors)['Recommendation_letter_use_cannabis']} errorMessage={(this.props.errors)['Recommendation_letter_use_cannabis']}/>
                        </div>
                        <button tabIndex={0} className={entry.Recommendation_letter_use_cannabis==="Yes"? 'inputBoxStyle-yes-no-left-selected' :'inputBoxStyle-yes-no-left'}
                               onClick={(event) => this.Recommendation_letter( "Yes")}>{t('patient_boarding.yes')}</button>
                        <button tabIndex={0} className={entry.Recommendation_letter_use_cannabis==="No"? 'inputBoxStyle-yes-no-right-selected' :'inputBoxStyle-yes-no-right'}
                                onClick={(event) => this.Recommendation_letter( "No")}>{t('patient_boarding.no')}</button>
                        <div className={'inputBoxStyle-yes-no-empty'}/>
                    </div>
                </div>

                {entry.Recommendation_letter_use_cannabis==="Yes" &&
                <div className={'inputSlotsDoc-full'}>
                    <label/>
                    <textarea className={'info-inputBoxStyle boxMargin'} defaultValue={entry.doctors_referral}
                              maxLength={"5000"}
                              onChange={(event) => this.props.onValueChange("doctors_referral", event.target.value)}/>

                </div>}

                <div className={'patientsFormRow'}>
                    <div className={'inputSlotsFlex'} id={'drug'}>
                        <div className={'infoLabel-error-block'}>
                            <label className={'infoLabel-withError'}>{t('patient_boarding.Hospitalizations_last_year')}?*</label>
                        </div>
                        <button tabIndex={0}  className={entry.Hospitalizations_last_year==="Yes"?  'inputBoxStyle-yes-no-left-selected' :'inputBoxStyle-yes-no-left'}
                                onClick={(event) => this.props.onYesNoValueChange("Hospitalizations_last_year", "Yes")}>{t('patient_boarding.yes')}</button>
                        <button tabIndex={0}  className={entry.Hospitalizations_last_year==="No"?'inputBoxStyle-yes-no-middle-selected' :'inputBoxStyle-yes-no-middle'}
                                onClick={(event) => this.props.onYesNoValueChange("Hospitalizations_last_year", "No")}>{t('patient_boarding.no')}</button>
                        <button tabIndex={0} className={entry.Hospitalizations_last_year==="Unknown"? 'inputBoxStyle-yes-no-right-selected' :'inputBoxStyle-yes-no-right'}
                                onClick={(event) => this.props.onYesNoValueChange("Hospitalizations_last_year", "Unknown")}>{t('patient_boarding.Unknown')}</button>
                    </div>
                </div>

                <div className={'blankSpace'}/>
            </div>

        )
    }
}

PatientOtherMedicalInfo.propTypes = {
    onValueChange:PropTypes.func.isRequired,
    entry: PropTypes.object.isRequired,
    isDisabled: PropTypes.bool
}

export default PatientOtherMedicalInfo;
